var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCounter)?_c('div',{staticClass:"countdownWrapper"},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('p',{key:_vm.foo[_vm.counter],staticClass:"countdown"},[_vm._v(" "+_vm._s(_vm.foo[_vm.counter])+" ")])])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }